import { useEffect } from "react";
import PropTypes from 'prop-types';
import { Row, Col } from "reactstrap";
import { useForm } from "react-hook-form";
import { toast } from "../../../../core/helpers/message-helper";
import FormModal from "../../../../core/ui/components/FormModal";
import InputController from "../../../../core/ui/components/InputController";
import { crearOEditarGrupo } from '../../services/permisos-grupos-service';

const FormGrupos = ({ modalState, onSave }) => {
    const { grupo } = modalState.data;

    const defaultValues = {
        id: grupo.id || "",
        nombre: grupo.nombre || "",
    };

    const form = useForm({ defaultValues });
    useEffect(() => form.reset(defaultValues), [grupo]);

    const onCreateGrupo = async (grupo) => {
        const resp = await crearOEditarGrupo(grupo);
        if (!resp.status) return toast.error(resp.message);

        toast.success(resp.message);
        modalState.close();
        onSave();
    };

    return (
        <FormModal
            size="lg"
            id="formGrupo"
            form={form}
            onSubmit={onCreateGrupo}
            isOpen={modalState.show}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    name="id"
                    type="hidden"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={12}>
                    <InputController
                        name="nombre"
                        label="Nombre"
                        errors={form.formState.errors}
                        control={form.control}
                        placeholder="Nombre"
                        rules={{ required: "Este campo es requerido" }}
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormGrupos.propTypes = {
    modalState: PropTypes.object,
    onSave: PropTypes.func
}

export default FormGrupos;
